import React from 'react';
import classnames from 'classnames';
import { isEmpty, get, defaultTo, cloneDeep, map, replace, endsWith, isEqual } from 'lodash';
import InputMask from 'react-input-mask';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { timeField as TimeField } from 'modules/TimeField';
 *
 * // render
 * <TimeField propName='propValue'/>
 */
export const timeField = ( props ) => {

    const[ time, setTime ] = React.useState( endsWith( props.value, ' PM' ) ? 'PM' : 'AM' );

     // get error message (ref)
     const errorMessage = get( props.error, 'message', null );
     const hasError = ! isEmpty( errorMessage );
 
    // dynamic class name
    const widgetClassName = classnames( 'ui-time-field', props.className, {
        'ui-time-field--error': hasError,
    } );
 
     const inputClassName = classnames( 'ui-time-field__box', {
         'ui-time-field__box--disabled': props.disabled || get( props, 'config.readonly', false ),
     } );
     
    const readonly = get( props, 'config.readonly', false );
    let displayValue = cloneDeep( props.value );

    if( '24' !== get( props, 'config.format', undefined ) ) {
        if( endsWith( displayValue, ' AM' ) ) {
            displayValue = replace( displayValue, ' AM', '' );
        } else if( endsWith( displayValue, ' PM' ) ) {
            displayValue = replace( displayValue, ' PM', '' );
        }
    }
 
    return (
        <div className={ widgetClassName }>
            
            {
                props.showLabel ? (
                    <div className='ui-time-field__label'>

                        {/* label text */}
                        <div className='ui-time-field__label__text'>{ getLabel( props.label ) }</div>

                        {/* required asterisk */}
                        {
                            props.required ? (
                                <div className='ui-time-field__label__asterisk'>*</div>
                            ) : null
                        }
                    </div>

                ) : null
            }

            <div className={ inputClassName }>
                <InputMask
                    type='text'
                    className={ 'ui-time-field__box__input' }
                    placeholder={ ! isEmpty( props.placeholder ) ? getLabel( props.placeholder ) : '' }
                    value={ defaultTo( displayValue, '' ) }
                    
                    // required={ props.required }
                    mask={ props.mask }
                    maxLength= { props.maxLength }
                    disabled = { props.disabled || get( props, 'config.readonly', false ) }
                    onChange={ ( event ) => props.onChange( {
                        name: props.name,
                        value: '24' !== get( props, 'config.format' ) ? `${event.target.value } ${ time }` : event.target.value,
                    } ) }

                    // maskPlaceholder= { '00:00' }
                />

                {/*  am/pm selection */}
                <div className="ui-time-field__box__btn">
               
                    { map( props.options, option => {

                        const optionClassName = classnames( 'ui-time-field__box__btn__action', {
                            'ui-time-field__box__btn__action--selected': isEqual( option.value, time )
                        } );

                        return (
                            <div key={ option.value } className={ optionClassName }
                            onClick={ () => {
                                setTime( option.value );

                                if( ! isEmpty( displayValue ) ) {

                                    props.onChange( {
                                        name: props.name,
                                        value: `${displayValue} ${ option.value }`,
                                    } );
                                }
                            } }>
                                { getLabel( option.title ) }
                            </div>
                        );

                    } ) }
                 </div>


                {/* icon */}
                { ! readonly && (
                    <div className='ui-time-field__box__icon'>
                        <Icon name={ 'time' } fill='#003e7b' width='16' height='16' />
                    </div>
                ) }
            </div>

            {
                hasError ? (
                    <div className='ui-time-field__error'>
                        <div className='ui-time-field__error__message'>
                            { getLabel( errorMessage ) }
                        </div>
                    </div>
                ) : null
            }

        </div>
    );
};

// set display name
timeField.displayName = 'timeField';

// set default props
timeField.defaultProps = {};

// prop types
timeField.propTypes = {};
